import { FieldBlock } from '@coast/schemas';
import { useContext, useMemo } from 'react';
import { CardChannelContext } from '@shared/components/blocks/contexts/channel';
import { MBFieldBlock } from '@shared/components/blocks/lib/field';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { useChannelUsers } from '@shared/util/hooks';
import { fieldPresenter } from './fieldPresenter';
import { useResolveAssignees } from './hooks';
import { MBAssigneeUserIcon } from './userIcon';

interface Props {
  value: number[];
  block: FieldBlock;
  onPress?(): void;
}

export function MBFieldAssigneeBlock({ value, block, onPress }: Props) {
  const channel = useContext(CardChannelContext);
  const { users: channelUsers } = useChannelUsers({ channelId: channel?.id });
  const { users } = useResolveAssignees(value, channelUsers);
  const renderLeft = useMemo(
    () => (users.length === 0 ? undefined : () => <MBAssigneeUserIcon users={users} />),
    [users],
  );

  return (
    <MBTouchableOpacity activeOpacity={1} onPress={onPress} disabled={!onPress}>
      <MBFieldBlock
        value={users}
        presenter={fieldPresenter}
        block={block}
        renderLeft={renderLeft}
      />
    </MBTouchableOpacity>
  );
}
